import CustomButtonColor from "../../Components/custom-button/CustomButtonColor";
import { useEffect, useRef, useState } from "react";
import "./OtpDialog.css";
import { t } from "i18next";
import { verifyBeforeAck } from "../../Services/api-service";

function OtpAckDialogWidget({ setSuccess, data, setIsLoading }) {
  const length = 8;
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const inputRefs = useRef([]);
  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
    const pageHeight = document.documentElement.scrollHeight;
    const pageWidth = document.documentElement.scrollWidth;
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const centerX = (pageWidth - viewportWidth) / 2;
    const centerY = (pageHeight - viewportHeight) / 2;
    window.scrollTo(centerX, centerY);
    document.body.style.overflow = "hidden";
  }, []);

  const handleSubmit = (input) => {
    var db = {data: data, code: input};
  setIsLoading(true);
    verifyBeforeAck(db, setIsLoading).then((data)=>{
      if(!data) setOtp(new Array(length).fill(""));
      else 
      {
        setSuccess(true);
      }
    });
  };
  const handleChange = async (index, e) => {
    const value = e.target.value;
    if (isNaN(value) || value === " ") return;

    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);
    const combinedOtp = newOtp.join("");

    if (combinedOtp.length === length) {
      handleSubmit(combinedOtp);
    }
    if (value && index < length - 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleClick = (index) => {
    inputRefs.current[index].setSelectionRange(1, 1);
    if (index > 0 && !otp[index - 1]) {
      inputRefs.current[otp.indexOf("")].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (
      e.key === "Backspace" &&
      !otp[index] &&
      index > 0 &&
      inputRefs.current[index - 1]
    ) {
      inputRefs.current[index - 1].focus();
    }
  };
  return (
    <div className="otp-ack-dialog-overlay">
      <div className="otp-dialog ack-dialog">
        <h2>{t("verifyotpack")}</h2>
        <p className="desc-otp">
          {t("verifyOtp1")}
          {/* <strong style={{ color: "#007AFF" }}>{objectDto.email}</strong> */}
          {t("verifyOtp2") }
        </p>

        <div className="otp-actions">
          <div className="otp-input-container">
            <div className="otp-input-label">
              { 
                otp.map((value, index) => {
                  return (
                    <input
                      key={index}
                      inputMode="numeric"
                      type="text"
                      ref={(input) => (inputRefs.current[index] = input)}
                      value={value}
                      onChange={(e) => handleChange(index, e)}
                      onClick={() => handleClick(index)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      className="otp-input"
                    />
                  );
                })}
            </div>
            <div className="otp-input-button">
              <CustomButtonColor
                size={"large"}
                title={t("confirmOtp")}
                color={"#fff"}
                borderRadius={"5px"}
                bgColor={"#c59812"}
                onClick={handleSubmit}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default OtpAckDialogWidget;
